import React, { Component } from "react"
import { UploadProgress, UploadProgressStore } from "@albelli/image-list-view-upload-progress"
import { locale } from "@albelli/photoselector"

interface Props {
  uploadStore: UploadProgressStore
  uploadProgress: UploadProgress
}

interface Stats {
  stats: {
    total: number
    uploaded: number
    serverData: number
    failed: number
    canceled: number
    timeLeft: number
  }
}

export default class StatsPanel extends Component<Props, Stats> {
  constructor(props: Props) {
    super(props)
    this.state = {
      stats: {
        total: 0,
        uploaded: 0,
        serverData: 0,
        failed: 0,
        canceled: 0,
        timeLeft: 0
      }
    }
    this.updateStats = this.updateStats.bind(this)
  }

  updateStats() {
    this.setState({ stats: this.props.uploadStore.statsGetData() })
  }

  componentDidMount() {
    this.updateStats()
    this.props.uploadProgress.subscribe("stats", this.updateStats)
  }

  componentWillUnmount() {
    this.props.uploadProgress.unsubscribe("stats", this.updateStats)
  }

  render() {
    const { stats } = this.state

    let timeLeft = ""
    if (stats.timeLeft === 0) {
      timeLeft = ""
    } else if (stats.timeLeft < 60 * 60) {
      timeLeft =
        locale.get().upload.estimatedleft + ": " + ("0" + Math.floor(stats.timeLeft / 60)).substr(-2) + ":" + ("0" + (stats.timeLeft % 60)).substr(-2)
    } else {
      const hours = Math.floor(stats.timeLeft / (60 * 60))
      const minutes = Math.floor((stats.timeLeft - hours * 60 * 60) / 60)
      const seconds = stats.timeLeft - (hours * 60 * 60 + minutes * 60)
      timeLeft =
        locale.get().upload.estimatedleft + ": " + ("0" + hours).substr(-2) + ":" + ("0" + minutes).substr(-2) + ":" + ("0" + seconds).substr(-2)
    }

    const total = stats.total
    const uploaded = stats.uploaded + stats.serverData + stats.canceled + stats.failed
    const progress = Math.round((uploaded / total) * 100)

    return (
      <div hidden={progress >= 100} className="mydevice-upload-statspanel">
        <div className="mydevice-upload-statspanel-stats">
          <div className="mydevice-upload-statspanel-stats-text" data-tam="upload-stats">
            <strong>
              {uploaded} / {total}
            </strong>
            {locale.get().upload.uploaded}
          </div>

          <div className="mydevice-upload-statspanel-progressbar-container" data-tam="upload-progressbar">
            <div
              className="mydevice-upload-statspanel-progressbar"
              style={{ background: "#50b7bc", height: "10px", width: progress > 0 ? progress + "%" : "0px" }}
            ></div>
          </div>

          <div hidden={stats.timeLeft === 0} className="mydevice-upload-statspanel-stats-timeleft" data-tam="upload-time-left">
            {timeLeft}
          </div>
          <div hidden={stats.timeLeft > 0} className="mydevice-upload-statspanel-stats-timeleft-dots" data-tam="upload-estimating-time">
            {locale.get().upload.estimating}
          </div>
        </div>
      </div>
    )
  }
}
